export const HILL_COUNTRY_ODN_ID = 'outdoorsy_hill_country';
export const YOSEMITE_ODN_ID = 'outdoorsy_yosemite';
export const BAYFIELD_ODN_ID = 'outdoorsy_bayfield';
